import React from "react";
import { filter, find, map, sumBy } from "lodash";
import { pure } from "recompose";

import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import GenericTable from "./GenericTable";
import { numberFormat, numberFormatM } from "./format";
import Auth from "routes/Auth";

const InventoryManagement = pure(
  ({
    inventoryBalances,
    competitiveAnalysis,
    teams,
    constants,
    products,
    teamId,
    competitionMetrics,
    rounds,
    round
  }) => {
    const data =
      Auth.getPosition() === "Student"
        ? competitiveAnalysis
        : competitionMetrics;
    const roundId = rounds.find(i => i.number === round).id;
    const teamInventory = filter(
      inventoryBalances,
      item => item.team === teamId && item.round === roundId
    );
    const chartData = map(teams, team => ({
      name: team.name,
      value: sumBy(
        filter(data, item => item.team === team.id),
        "Available For Sale"
      )
    }));

    return (
      <OnePanelChart
        title="Inventory Management"
        chartTitle="Volume"
        data={chartData}
        format={numberFormatM}
        teams={teams}
        yaxisFormatter={numberFormat}
      >
        <Text>
          {numberFormat(sumBy(teamInventory, "units_sold"))} of units available
          for sale were sold, leaving{" "}
          {numberFormat(sumBy(teamInventory, "ending_inventory"))} of unsold
          inventory. All teams incur a{" "}
          {(constants["holding_rate"] * 100).toFixed(1)}% costs of holding
          ending inventory.
        </Text>
        <GenericTable
          header={[
            { name: "Product Name", highlighted: true },
            { name: "Available for Sales", highlighted: true },
            { name: "", highlighted: false },
            { name: "Units Sold", highlighted: true },
            { name: "", highlighted: false },
            { name: "Ending Inventory", highlighted: true }
          ]}
          rows={map(teamInventory, item => [
            (find(products, product => product.id === item.product) || {}).name,
            numberFormat(item["available_for_sale"]),
            "-",
            numberFormat(item["units_sold"]),
            "=",
            numberFormat(item["ending_inventory"])
          ])}
        />
        <Text>
          <b>Note</b>: Units available for sale is the combination of your
          beginning inventory plus any units produced in the current round.
        </Text>
      </OnePanelChart>
    );
  }
);

export default InventoryManagement;



// WEBPACK FOOTER //
// ./src/components/analysis/InventoryManagement.js